// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentProviderGeneralSettingsController = function ($scope, $location, $routeParams, $http, GeneralPaymentSettings, gettextCatalog, gettext) {
    $scope.generalPaymentSettings = GeneralPaymentSettings.get();

    $scope.additionalRetryEnabled = false;
    $scope.additionalRetryDaysInput = '1,2';
    $scope.additionalRetryDaysError = '';

    $scope.generalPaymentSettings.$promise.then(function () {
        var arr = $scope.generalPaymentSettings.RetryAttemptsForInsufficientBalanceDays;
        if (Array.isArray(arr)) {
            $scope.additionalRetryEnabled = arr.length > 0;
            $scope.additionalRetryDaysInput = arr.length > 0 ? arr.join(',') : '1,2';
        }
    });

    function validateAdditionalRetryDaysInput(input) {
        let trimmed = input ? input.trim() : '';
        if (!trimmed)
            return { valid: false, error: _txt(gettext("Value is required when enabled.")) };
        if (!/^\d+(,\d+)*$/.test(trimmed))
            return { valid: false, error: _txt(gettext("Invalid format. Use comma-separated numbers, e.g. 1,2,5.")) };
        let parts = trimmed.split(',').map(function (s) {
            return parseInt(s, 10);
        });
        for (let i = 0; i < parts.length - 1; i++) {
            if (parts[i] >= parts[i + 1])
                return { valid: false, error: _txt(gettext("Each number must be greater than the previous one.")) };
        }
        if (parts[0] < 1)
            return { valid: false, error: _txt(gettext("The first number cannot be smaller than 1.")) };
        if (parts[parts.length - 1] > 30)
            return { valid: false, error: _txt(gettext("The highest number cannot exceed 30.")) };
        return { valid: true, array: parts };
    }

    $scope.onAdditionalRetryEnabledChange = function () {
        if (!$scope.additionalRetryEnabled) {
            $scope.generalPaymentSettings.RetryAttemptsForInsufficientBalanceDays = [];
        } else {
            const result = validateAdditionalRetryDaysInput($scope.additionalRetryDaysInput);
            if (result.valid) {
                $scope.generalPaymentSettings.RetryAttemptsForInsufficientBalanceDays = result.array;
            } else {
                $scope.generalPaymentSettings.RetryAttemptsForInsufficientBalanceDays = [1, 2];
            }
        }
        $scope.additionalRetryDaysError = '';
    };

    $scope.onAdditionalRetryDaysInputChange = function () {
        $scope.additionalRetryDaysError = '';
        if (!$scope.additionalRetryEnabled) return;
        var result = validateAdditionalRetryDaysInput($scope.additionalRetryDaysInput);
        if (result.valid) {
            $scope.generalPaymentSettings.RetryAttemptsForInsufficientBalanceDays = result.array;
        } else {
            $scope.additionalRetryDaysError = result.error;
        }
    };

    $scope.save = function () {
        if ($scope.additionalRetryEnabled) {
            var result = validateAdditionalRetryDaysInput($scope.additionalRetryDaysInput);
            if (!result.valid) {
                $scope.additionalRetryDaysError = result.error;                
                return;
            }
            $scope.generalPaymentSettings.RetryAttemptsForInsufficientBalanceDays = result.array;
        } else {
            $scope.generalPaymentSettings.RetryAttemptsForInsufficientBalanceDays = [];
        }
        $scope.generalPaymentSettings.$update({}, function () {
            $scope.notifySuccess();
            $scope.additionalRetryDaysError = '';
        });
    };

    if (GeneralPaymentSettings.queryPlaceHolderDescription) {
        GeneralPaymentSettings.queryPlaceHolderDescription(function (response) {
            $scope.mandateReferencePlaceHolderDescription = response.data;           
        });
    }
    if (GeneralPaymentSettings.queryPlaceHolders) {
        GeneralPaymentSettings.queryPlaceHolders(function (response) {
            $scope.mandateReferencePlaceHolders = response.data;
        });
    }

    $scope.getTooltip = function (placeholder) {
        var res = ($scope.mandateReferencePlaceHolderDescription)
            ? $scope.mandateReferencePlaceHolderDescription[placeholder]
            : null;
        return res;
    };
    const Merchant = 'Merchant';
    //TODO: IT-10186 - define constants on server side
    $scope.mandateTextPlaceHolders = Object.freeze({
            Merchant : ['Merchant.CreditorId', 'Merchant.CompanyName', 'Merchant.AddressLine1', 'Merchant.AddressLine2', 'Merchant.StreetAddress', 'Merchant.HouseNumber', 'Merchant.ZIP', 'Merchant.City', 'Merchant.Country', 'Merchant.Phone', 'Merchant.Website', 'Merchant.EmailAddress'],
            'Customer' : ['FirstName', 'LastName','CompanyName','EmailAddress', 'StreetAddress', 'ZIP', 'City', 'Country'],
            'Direct Debit': ['Pay.BIC', 'Pay.IBAN', 'Pay.Holder', 'Pay.MandateReference'],
            'General' : ['CurrentDay']
    });
  
    $scope.currentMandateText = Merchant;
    $scope.isVisibleMandateTextPlaceHolder = function(phGroupName) {
        return $scope.currentMandateText === phGroupName;
    };
    $scope.toggleMandateTextVisibility = function(itemName) {
        if ($scope.currentMandateText === itemName)
            $scope.currentMandateText = null;
        else
            $scope.currentMandateText = itemName;
    };

    $scope.currentMandateRef = Merchant;
    $scope.isVisibleMandateRefPlaceHolder = function(phGroupName) {
        return $scope.currentMandateRef === phGroupName;
    };
    $scope.toggleMandateRefVisibility = function(itemName) {
        if ($scope.currentMandateRef === itemName)
            $scope.currentMandateRef = null;
        else
            $scope.currentMandateRef = itemName;
    };

    function _txt(msg) {
        return gettextCatalog.getString(msg);
    }    
};
PaymentProviderGeneralSettingsController.$inject = ['$scope', '$rootScope', '$routeParams', '$http', 'GeneralPaymentSettings', 'gettextCatalog', 'gettext'];
